<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h4>Password Expiration Management</h4>
    </div>
  </div>

  <hr style="margin-top:2px;margin-bottom:2px" />
  <br />

  <div class="row">
    <div class="col-xs-12 col-md-6">
      <aims-form cols="1">
        <aims-fc>
          <mat-form-field>
            <input matInput #aimsControl="ngModel" name="Password Expiration Days" type="number" min="0"
              [(ngModel)]="passwordConfig.passwordExpirationDays">
          </mat-form-field>
        </aims-fc>

        <aims-fc>
          <mat-form-field>
            <input matInput #aimsControl="ngModel" name="Password Reset Days" type="number" min="0"
              [(ngModel)]="passwordConfig.passwordResetDays">
          </mat-form-field>
        </aims-fc>
      </aims-form>

      <aims-common-button (click)="setPasswordConfig()" attr.aria-label="Update Password Configuration">
        Update Password Configuration
      </aims-common-button>
    </div>
  </div>
</div>